import angular from 'angular';
// import dayjs from 'dayjs';
import { AncillariesUtilsService } from '../../../../../../shared/ib-web-ancillaries-utils';
import { DatalayerUtils } from 'src/app/shared/ib-datalayer-utils';
import { DatalayerConstantsType } from 'ib-web-commons/app/core/ib-datalayer/ib-datalayer-constants';

const componentOptions = {
    bindings: {
        bobInfo: '=',
        isLoading: '=',
        bobOrder: '=',
        showBobOrderSummary: '=',
        showBobOrderError: '='
    },
    controllerAs: 'bobFormCtrl',
    templateUrl: ['$rootScope', function ($rootScope) {
        return $rootScope.routes.templates + 'ib-bob-form-view.html';
    }]
};


const componentInfo = {
    module: 'ib-bob-form-module',
    selector: 'ibBobForm',
    inject: ['$rootScope', '$scope', '$compile', 'IbBobFormModel', 'AncillariesUtilsService', 'localStorageService', 'CurrencyService', 'IbBobFormService', 'BobFormTransformer', '$sce', '$timeout', 'AncillariesConstants', '$filter', 'DatalayerUtilsService', 'DatalayerUtils', 'CommonsConstants', 'CommonsUtilService', 'DatalayerConstants'],
    required: ['']
};

export class ibBobForm implements ng.IController {

    public tooltipOpened = false;
    public isLoading = true;
    public model;
    public prefixes;
    public bobInfo;
    public bobForm;
    public tooltipComponent;
    public bobOrder;
    public deleteBaggage;
    public addBaggage;
    public showBobOrderSummary;
    public showBobOrderError;
    constructor (
        private $rootScope: CommonsRootScope,
        private $scope: angular.IScope,
        private $compile: angular.ICompileService,
        private IbBobFormModel: any,
        private AncillariesUtilsService: AncillariesUtilsService,
        private localStorageService: angular.local.storage.ILocalStorageService,
        private CurrencyService: CurrencyService,
        private IbBobFormService: any,
        private BobFormTransformer: any,
        private $sce: any,
        private $timeout: ng.ITimeoutService,
        private AncillariesConstants: AncillariesConstant,
        private $filter: angular.IFilterService,
        private DatalayerUtilsService: DatalayerUtilsService,
        private DatalayerUtils: DatalayerUtils,
        private CommonsConstants: CommonsConstantsType,
        private CommonsUtilService: CommonsUtilService,
        private DatalayerConstants: DatalayerConstantsType) {
        this.$scope.$on('setModelStorage', this.setModelStorage);

    }

    $onInit () {
        this.model = this.IbBobFormModel.initializeModel(this.bobInfo);
        this.prefixes = this.localStorageService.get('prefixesList') || this.localStorageService.get('phoneCodeList');
        this.prefixes.splice(0, 1);
        this.model.phoneFocus = false;
        this.model.emailFocus = false;
        const contactApi = this.localStorageService.get('disruptionContactApis');
        let key;
        const model = this.localStorageService.get('bobFormModel');

        this.model.email = null;
        this.model.phone = null;
        this.model.countryCode = null;
        this.IbBobFormService.initBobModal(this.model.services).then((data) => {

            this.model.services = this.BobFormTransformer.generateMatchPickUp(this.model.services, data.pickUpData);
            this.model.text = this.$sce.trustAsHtml('<span class="ib-check__text" >' + data.text + '</span>');
            this.isLoading = false;

            if (contactApi) {
                this.model.email = contactApi[0].disruptionContact && contactApi[0].disruptionContact.email
                    ? contactApi[0].disruptionContact.email : null;
                this.model.phone = contactApi[0].disruptionContact && contactApi[0].disruptionContact.phone.number ?
                    contactApi[0].disruptionContact.phone.number : null;
                this.model.countryCode = contactApi[0].disruptionContact && contactApi[0].disruptionContact.phone.countryCode.code ?
                    contactApi[0].disruptionContact.phone.countryCode.code : null;
            }
            const isFlowBob = this.localStorageService.get('flowBob');
            if (isFlowBob) {
                const passengers = this.localStorageService.get('passengers');
                const passenger = passengers[0];
                this.model.email = passenger?.contactInfo?.email;
                this.model.phone = passenger?.contactInfo?.phoneDetails?.number;
                this.model.countryCode = passenger?.contactInfo?.phoneDetails?.countryCode;
                this.localStorageService.remove('flowBob');
            }
            this.model.priceTotal = 0;
            this.model.totalFormatted = this.CurrencyService.formatPrice(this.bobInfo.slices[0].products[0].currency, this.model.priceTotal, true, false, false);
            if (data.pickUpData[0].errorCode) {
                this.$timeout(() => {
                    key = 'slot' + this.model.services[0].sliceId;
                    this.bobForm[key].$showError = true;
                    this.cleanFieldsErrors(key, data.pickUpData[0].message, true);
                }, 500);

            }
            if (model) {
                this.model = this.BobFormTransformer.generateModelStorage(this.model, model);
            }
        }, (error) => {
            key = 'slot' + this.model.services[0].sliceId;
            this.cleanFieldsErrors(key, error.message, true);
        });
    }

    //#region ToolTip Baggages

    // Tooltip Hover
    tooltipHover = (passenger, position, index, event): void => {
        if (!this.AncillariesUtilsService.isTouchDevice()) {
            this.buildTooltipHover(passenger, position, index, event);
            this.tooltipOpened = true;
        }
    };

    /**
     * Generate tooltip and append to DOM
     * @param {*} passenger
     * @param {*} position
     * * @param {*} index
     * @param {*} event
     */
    buildTooltipHover = (passenger: any, position: any, index: any, event: any): void => {

        if (angular.element('#tooltipHover').length > 0) {
            angular.element('#tooltipHover').remove();
        }

        if (position === this.AncillariesConstants.DIRECTION.LEFT) {
            const tooltipLeft = angular.element(('<div id="tooltipHover" class="ib-add-bag-tooltip ib-add-bag-tooltip--left ib-add-bag-tooltip--extra-one" style="display: block">'
                + '<div class="ib-add-bag-tooltip__container">'
                + '<span class="ib-add-bag-tooltip__text">' + this.calculatePriceBaggage(passenger, position, index) + '</span>'
                + '</div>'
                + '<div class="ib-add-bag-tooltip__arrow"></div>'
                + '</div>'
            ));
            angular.element(event.target).parent().append(this.$compile(tooltipLeft)(this.$scope));
            this.tooltipComponent = tooltipLeft;
        } else {
            const tooltipRight = angular.element(('<div  id="tooltipHover" class="ib-add-bag-tooltip ib-add-bag-tooltip--right ib-add-bag-tooltip--extra-one" style="display: block">'
                + '<div class="ib-add-bag-tooltip__container">'
                + ' <span class="ib-add-bag-tooltip__text">' + this.calculatePriceBaggage(passenger, position, index) + '</span>'
                + '</div>'
                + '<div class="ib-add-bag-tooltip__arrow"></div>'
                + '</div>'
            ));

            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
        }
        if (
            (position === this.AncillariesConstants.DIRECTION.LEFT && passenger.numBags === 0) ||
            (position === this.AncillariesConstants.DIRECTION.RIGHT && passenger.numBags === 9)
        ) {
            angular.element('#tooltipHover').remove();
        }

    };

    /**
     * Check type of device, build tooltip and append to view
     * @param {*} passenger
     * @param {*} position
     * @param {*} indexSlice
     * @param {*} event
     */
    tooltipTouch = (passenger, position, indexSlice, event): void => {
        this.localStorageService.set('lastFieldBob', 'maleta');
        if (!this.AncillariesUtilsService.isTouchDevice()) {
            position === 'left' ? passenger.numBags-- : passenger.numBags++;
            position === 'left' ? this.model.services[indexSlice].baggage-- : this.model.services[indexSlice].baggage++;
            this.tooltipHover(passenger, position, indexSlice, event);
            this.calculateTotalTrip(passenger);
        }

        if (this.AncillariesUtilsService.isTouchDevice() === true && !this.tooltipOpened) {
            this.buildTooltipTouch(passenger, position, indexSlice, event);
            this.tooltipOpened = true;
        } else if (this.AncillariesUtilsService.isTouchDevice() === true && this.tooltipOpened) {
            this.tooltipComponent.css('display', 'none');
            this.tooltipOpened = false;
            this.buildTooltipTouch(passenger, position, indexSlice, event);
            this.tooltipOpened = true;
        }

        if (this.model.numBagsTotal > 0) {
            this.DatalayerUtils.bobEcommerceEventSelected(this.model);
        }
    };

    /**
     * Build tooltip touch and append to view
     * @param {*} passenger
     * @param {*} position
     * * @param {*} index
     * @param {*} event
     */
    buildTooltipTouch = (passenger: any, position: any, index: any, event: any): any => {

        if (angular.element('#toolTipTouch').length > 0) {
            angular.element('#toolTipTouch').remove();
        }

        const tooltipLeft = angular.element('<div id="toolTipTouch" class="ib-add-bag-tooltip-touch ib-add-bag-tooltip-touch--left ib-add-bag-tooltip-touch--extra-one">' +
            '<div class="ib-add-bag-tooltip-touch__container">' +
            '<span class="ib-add-bag-tooltip-touch__text">' + this.$filter('translate')('PRICE_TEXT') + ' ' + this.calculatePriceBaggage(passenger, position, index) + '</span>' +
            '<button type="button" class="ib-button ib-button-medium ib-add-bag-tooltip-touch__button ib-add-bag-tooltip-touch__button--remove" data-ng-click="bobFormCtrl.deleteBaggage()">' + this.$filter('translate')('DELETE_TEXT') + '</button>' +
            '</div>' +
            '<div class="ib-add-bag-tooltip-touch__arrow ib-add-bag-tooltip-touch__arrow--big"></div>' +
            '</div>');

        const tooltipRight = angular.element('<div id="toolTipTouch" class="ib-add-bag-tooltip-touch ib-add-bag-tooltip-touch--right ib-add-bag-tooltip-touch--extra-one">' +
            '<div class="ib-add-bag-tooltip-touch__container">' +
            '<span class="ib-add-bag-tooltip-touch__text">' + this.$filter('translate')('PRICE_TEXT') + ' ' + this.calculatePriceBaggage(passenger, position, index) + '</span>' +
            '<button type="button" class="ib-button ib-button-medium ib-add-bag-tooltip-touch__button ib-add-bag-tooltip-touch__button--add" data-ng-click="bobFormCtrl.addBaggage()">' + this.$filter('translate')('BUTTON_ADD_TEXT') + '</button>' +
            '</div>' +
            '<div class="ib-add-bag-tooltip-touch__arrow ib-add-bag-tooltip-touch__arrow--big"></div>' +
            '</div>');


        if (position === this.AncillariesConstants.DIRECTION.LEFT) {
            angular.element(event.target).parent().append(this.$compile(tooltipLeft)(this.$scope));
            this.tooltipComponent = tooltipLeft;
            this.tooltipComponent.css({ display: 'block' });
        } else {
            angular.element(event.target).parent().append(this.$compile(tooltipRight)(this.$scope));
            this.tooltipComponent = tooltipRight;
            this.tooltipComponent.css({ display: 'block' });
        }

        this.deleteBaggage = function () {
            passenger.numBags--;
            this.model.services[index].baggage--;
            this.this.calculateTotalTrip(passenger);
            if (passenger.numBags === 0) {
                angular.element('#toolTipTouch').remove();
            } else {
                const textPrice = this.$filter('translate')('PRICE_TEXT') + ' ' + this.calculatePriceBaggage(passenger, position, index);
                angular.element('.ib-add-bag-tooltip-touch__text').text(textPrice);
            }
            this.tooltipOpened = false;
        };

        this.addBaggage = function () {
            passenger.numBags++;
            this.model.services[index].baggage++;
            this.this.calculateTotalTrip(passenger);
            if (passenger.numBags === 9) {
                angular.element('#toolTipTouch').remove();
            } else {
                const textPrice = this.$filter('translate')('PRICE_TEXT') + ' ' + this.calculatePriceBaggage(passenger, position, index);
                angular.element('.ib-add-bag-tooltip-touch__text').text(textPrice);
            }
            this.tooltipOpened = false;
        };
    };

    clickCloseOutsideClick = (e): void => {
        if (!angular.element('ib-add-bag-tooltip-touch').is(':visible') && !angular.element(e.target).hasClass('ib-add-bag-tooltip-touch__container') && !angular.element(e.target).hasClass('ib-add-bags__button') && !angular.element(e.target).hasClass('ib-add-bag-tooltip-touch__button') && !angular.element(e.target).hasClass('ib-add-bag-tooltip-touch__text')) {
            angular.element('.ib-add-bag-tooltip-touch').css('display', 'none');
        }
    };

    destroyCloseOusideClick = (): void => {
        angular.element('.modal-content').off('click', this.clickCloseOutsideClick);
    };

    closeOusideClick = (): void => {
        angular.element('.modal-content').on('click', this.clickCloseOutsideClick);
    };

    //#endregion

    //#region Prices
    /**
     * Calculate total price of the passenger with number
     * of baggages selected by user
     * @param {Object} passenger Information of the passenger
     */
    calculateTotalTrip = (passenger: any): void => {
        const numBag = 1;
        passenger.priceTotalBags = 0;
        if (numBag === passenger.numBags) {
            passenger.priceTotalBags = this.model.priceFrom;
        } else if (numBag < passenger.numBags) {
            passenger.priceTotalBags = this.model.priceFrom + ((passenger.numBags - numBag) * this.model.priceAdditionalBags);
        }
        this.calculateTotalBaggages();
    };

    /**
     * Calculate total to pay for all baggages selected
     */
    calculateTotalBaggages = (): void => {
        let totalBaggages = 0, totalPriceBaggages = 0, additionalBaggage,
            baggageSlice, priceOneBaggage = 0;
        const currency = this.bobInfo.slices[0].products[0].currency;
        angular.forEach(this.model.services, (service) => {
            baggageSlice = 0;
            angular.forEach(service.passengers, (passenger) => {
                totalBaggages += passenger.numBags;
                baggageSlice += passenger.numBags;
            });
            additionalBaggage = (baggageSlice - 1) <= 0 ? 0 : (baggageSlice - 1);
            priceOneBaggage = baggageSlice <= 0 ? 0 : (this.model.priceFrom * 1);
            totalPriceBaggages += (priceOneBaggage) + (additionalBaggage * this.model.priceAdditionalBags);
        });
        this.model.numBagsTotal = totalBaggages;
        this.model.priceTotal = totalPriceBaggages;
        this.model.totalFormatted = this.CurrencyService.formatPrice(currency, totalPriceBaggages, true, false, false);
    };

    /**
     * Calculate price of next baggage depeding of price range
     * returned by service
     * @param {} passenger
     * @param position
     */
    calculatePriceBaggage = (passenger: any, position: any, index: any): string => {
        let totalBaggages = 0, totalPriceBaggages = 0, additionalBaggage,
            baggageSlice, priceOneBaggage = 0;
        const sliceIndex = index;
        const currency = this.bobInfo.slices[0].products[0].currency;
        angular.forEach(this.model.services, (service, key) => {
            baggageSlice = 0;
            angular.forEach(service.passengers, (passenger) => {
                baggageSlice += passenger.numBags;
            });
            if (key === sliceIndex) {
                totalBaggages = baggageSlice;
            }
            additionalBaggage = (baggageSlice - 1) <= 0 ? 0 : (baggageSlice - 1);
            priceOneBaggage = baggageSlice <= 0 ? 0 : (this.model.priceFrom * 1);
            totalPriceBaggages += (priceOneBaggage) + (additionalBaggage * this.model.priceAdditionalBags);
        });
        if (position === 'left') {
            if (totalBaggages > 1) {
                totalPriceBaggages -= this.model.priceAdditionalBags;
            } else if (totalBaggages === 1) {
                totalPriceBaggages -= this.model.priceFrom;
            } else {
                totalPriceBaggages = 0;
            }
        } else {
            if (totalBaggages >= 1) {
                totalPriceBaggages += this.model.priceAdditionalBags;
            } else {
                totalPriceBaggages += this.model.priceFrom;
            }
        }
        return this.CurrencyService.formatPrice(currency, totalPriceBaggages, false, false, false);
    };

    close = (): void => {
        this.$scope.$emit('closeBobModal');
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };


    setModelStorage = (): void => {
        this.localStorageService.set('bobFormModel', this.model);
    };

    selectSlot = (data: any, index: any): void => {
        this.localStorageService.set('lastFieldBob', 'slot horario');
        this.model.services[index].pickUpSlot.selectedPickup = data;
        this.model.services[index].pickUpSlot.selectedSlot = null;
    };


    setSlotLocalStorage = (): void => {
        this.localStorageService.set('lastFieldBob', 'slot horario');
    };


    addressValidation = (airportCode: any, indexSlice: any): void => {
        this.localStorageService.set('lastFieldBob', 'direccion');
        const id = this.model.services[indexSlice].sliceId;
        const key = 'address' + id;
        if (this.model.services[indexSlice].address === '' || this.model.services[indexSlice].address === null || angular.isUndefined(this.model.services[indexSlice].address)) {
            this.model.services[indexSlice].addressReturned = null;
            this.model.services[indexSlice].address = null;
            this.model.messageAddress = null;
            if (this.model.services[indexSlice].complementAddress === '' || this.model.services[indexSlice].complementAddress === null || angular.isUndefined(this.model.services[indexSlice].complementAddress)) {
                this.model.services[indexSlice].complementAddress = null;
            }
            this.cleanFieldsErrors(key, null, false);
            return;
        }
        this.bobForm[key].$sendToError = true;
        this.isLoading = true;
        const json = {
            area: airportCode,
            address: this.model.services[indexSlice].address
        };

        this.IbBobFormService.validateBobAddress(json).then((data) => {
            this.cleanFieldsErrors(key, '', false);
            this.model.messageAddress = null;
            this.model.services[indexSlice].addressReturned = this.changeKeyName(this.cleanNullValue(data));
            this.model.services[indexSlice].complementAddress === '' || angular.isUndefined(this.model.services[indexSlice].complementAddress) ?
                '' : this.model.services[indexSlice].addressReturned.extraInfo = this.model.services[indexSlice].complementAddress;
            this.model.services[indexSlice].addressReturned.location = this.changeKeyName(this.model.services[indexSlice].addressReturned.location);
            this.isLoading = false;
        }, (error) => {
            this.DatalayerUtilsService.sendDatalayerErrorEvent({
                eventCategory: this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB_STEP + 2,
                eventAction: this.AncillariesConstants.DATALAYER_INFO.CLICK,
                eventLabel: this.AncillariesConstants.DATALAYER_INFO.FOLLOW_ERROR,
                internalErrorCode: error.internalErrorCode,
                errorCode: error.errorCode,
                message: error.message

            });
            this.model.messageAddress = error.message;
            this.cleanFieldsErrors(key, error.message, true);
            this.isLoading = false;
        });
    };
    updateDataLayerAndDigitalData = (): void => {
        const flow = this.localStorageService.get('flowApp');
        let quadrigam = '';
        switch (flow) {
                case this.AncillariesConstants.APPLICATION_FLOW.BBOOKING:
                case this.AncillariesConstants.APPLICATION_FLOW.BOOKING:
                    quadrigam = this.CommonsConstants.STEP_FLOW.ANCILLARIES.toUpperCase();
                    break;
                case this.AncillariesConstants.APPLICATION_FLOW.CHECKIN:
                    quadrigam = this.AncillariesConstants.QUADRIGAM.ANCILLARIES;
                    break;
        }
        /* INIT DELETE GA4 MIGRATION */
        this.DatalayerUtilsService.updateDatalayerWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.setProcessAndStep(this.CommonsUtilService.getProcess(), this.DatalayerConstants.DATALAYER_ANCILLARIES.ANCILLARIES, quadrigam);
        this.DatalayerUtilsService.sendDatalayerEvent(this.DatalayerConstants.DATALAYER_EVENT_TYPES.VIEW);
        /* FINISH DELETE GA4 MIGRATION*/
        this.DatalayerUtilsService.updateDigitalDataWithQuadrigam(quadrigam, null, this.localStorageService.get('userLogged'));
        this.DatalayerUtilsService.updateDatalayerViewEvent();
    };
    completeForm = (): void => {
        let json: any = {};

        this.DatalayerUtilsService.updateDatalayerEvents(this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB, this.AncillariesConstants.DATALAYER_INFO.STEP_ONE, this.AncillariesConstants.DATALAYER_INFO.CONTINUE, this.AncillariesConstants.DATALAYER_INFO.INTERACCION);

        this.bobForm.$submitted = true;
        if (this.bobForm.$valid) {
            this.sendDatalayerInfo();
            this.isLoading = true;
            json = this.BobFormTransformer.createJsonComplete(this.model, this.bobInfo);
            const flowApp = this.localStorageService.get('flowApp');
            if (flowApp==='MMB') {
                const bookingInfo : any = this.localStorageService.get('bookingInfo');
                const slices = bookingInfo.order.slices;
                json.services.forEach((service)=>{
                    slices.forEach((slice)=>{
                        if(service.sliceId === slice.sliceId) {
                            service.flightInfo = this.getFlightInfo(slice);
                        }
                    });
                });
            }
            this.IbBobFormService.createBobOrder(json).then((data) => {
                this.bobOrder = data;
                this.showBobOrderSummary = true;
                angular.forEach(this.bobOrder.summary, (slice, index) => {
                    //  this.bobOrder.summary[index].date = dayjs(json.services[index].pickUpSlot.date).format('DD/MM/YYYY');
                    this.bobOrder.summary[index].slot = json.services[index].pickUpSlot.from + ' - ' + json.services[index].pickUpSlot.to;
                    this.bobOrder.summary[index].address = json.services[index].addressInfo.street;
                    this.bobOrder.summary[index].email = json.email.toUpperCase();
                });

                this.DatalayerUtils.bobEcommerceEventAddToCard(this.model);

                this.localStorageService.set('bobOrder', this.bobOrder);
                this.$rootScope.$broadcast('setQuantityBob');
                this.isLoading = false;
            }, (error) => {
                this.DatalayerUtilsService.sendDatalayerErrorEvent({
                    eventCategory: this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB_STEP + 2,
                    eventAction: this.AncillariesConstants.DATALAYER_INFO.CLICK,
                    eventLabel: this.AncillariesConstants.DATALAYER_INFO.FOLLOW_ERROR,
                    internalErrorCode: error.internalErrorCode,
                    errorCode: error.errorCode,
                    message: error.message

                });
                this.showBobOrderError = true;
                this.isLoading = false;
            });
        }
        this.$rootScope.$broadcast('updateDatalayer');
        this.$rootScope.$broadcast('updatePageType');
    };

    getFlightInfo = (slice: any) => {
        let flightInfo, flightSegments, flightNumbers;

        flightSegments = {
            arrivalFlight: slice.segments[0].arrival.code,
            departureFlight: slice.segments[0].departure.code
        },
        flightNumbers = {
            number: slice.segments[0].flight.operationalDisclosure + slice.segments[0].flight.operationalFlightNumber,
            date: slice.departureDateTime.substring(0, 10)
        },
        flightInfo = {
            flightSegments : [flightSegments],
            flightNumbers : [flightNumbers]
        };
        return flightInfo;
    };

    sendDatalayerInfo = (): void => {
        this.DatalayerUtilsService.updateDatalayerEvents(
            this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB,
            this.AncillariesConstants.DATALAYER_INFO.STEP_ONE,
            this.AncillariesConstants.DATALAYER_INFO.BAGGAGE_ADD_BOB + this.AncillariesConstants.DATALAYER_INFO.OK,
            this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
        this.DatalayerUtilsService.updateDatalayerEvents(
            this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB,
            this.AncillariesConstants.DATALAYER_INFO.STEP_ONE,
            this.AncillariesConstants.DATALAYER_INFO.ADDRESS_ADD_BOB + this.AncillariesConstants.DATALAYER_INFO.OK,
            this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
        this.DatalayerUtilsService.updateDatalayerEvents(
            this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB,
            this.AncillariesConstants.DATALAYER_INFO.STEP_ONE,
            this.AncillariesConstants.DATALAYER_INFO.SLOT_ADD_BOB + this.AncillariesConstants.DATALAYER_INFO.OK,
            this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
        this.DatalayerUtilsService.updateDatalayerEvents(
            this.AncillariesConstants.DATALAYER_INFO.MODULE_BOB,
            this.AncillariesConstants.DATALAYER_INFO.STEP_ONE,
            this.AncillariesConstants.DATALAYER_INFO.INFO_ADD_BOB + this.AncillariesConstants.DATALAYER_INFO.OK,
            this.AncillariesConstants.DATALAYER_INFO.INTERACCION);
    };

    onValidateMessages = (formField: any, id: any): any => {
        return this.$scope.$eval('vm.bobForm["' + formField + id + '"]$error');
    };


    cleanNullValue = (data: any): any => {
        angular.forEach(data, (value, key) => {
            if (value === null || angular.isUndefined(value) || value === '') {
                delete data[key];
            }
        });
        return data;
    };
    changeKeyName = (data: any) => {
        angular.forEach(data, (value: any, key: any) => {
            switch (key) {
                    case 'lat':
                        data.latitude = value;
                        delete data[key];
                        break;
                    case 'lng':
                        data.longitude = value;
                        delete data[key];
                        break;
                    case 'postalcode':
                        data.postalCode = value;
                        delete data[key];
                        break;
                    default:
                        break;
            }
        });
        return data;
    };

    cleanFieldsErrors = (key: any, value: any, boolean: any): void => {
        this.bobForm[key].$error.service = boolean;
        this.bobForm[key].$sendToError = boolean;
        this.bobForm[key].$invalid = boolean;
        this.bobForm[key].$error.message = value;
        if (!boolean) {
            this.bobForm[key].$valid = true;
        }
    };

    setInformationContact = (): void => {
        this.localStorageService.set('lastFieldBob', 'informacion contacto');
    };

}



try {
    const mod = angular.module(componentInfo.module);
    ibBobForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobForm })
    );
} catch (error) {
    const mod = angular.module(componentInfo.module, componentInfo.required);
    ibBobForm.$inject = componentInfo.inject;
    mod.component(
        componentInfo.selector,
        angular.extend(componentOptions, { controller: ibBobForm })
    );
}